import { agentPost, agentGet } from "@/plugins/request";

export default {
  login: (data) =>
    agentPost("/login", data, {
      headers: { isToken: false, repeatSubmit: false },
    }),
  getCodeImg: (params) =>
    agentGet("/captcha", params, {
      headers: { isToken: false },
      timeout: 20000,
    }),
  getInfo: () => agentGet("/getInfo"),
  logout: () => agentGet("/logout"),
  sendResetCode: (data) =>
    agentPost("/forgot-password/code", data, { headers: { isToken: false } }),
  resetPasswordByCode: (data) =>
    agentPost("/forgot-password", data, { headers: { isToken: false } }),
};
